/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_P3dInputs */

const en_mk_sol_ukm_p3d = /** @type {(inputs: Mk_Sol_Ukm_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday’s promo gets prepared on Sunday night, so its quality depends on who happens to still be awake.`)
};

const id_mk_sol_ukm_p3d = /** @type {(inputs: Mk_Sol_Ukm_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promo Senin baru disiapkan Minggu malam, jadi kualitasnya bergantung pada siapa yang kebetulan masih bangun.`)
};

/**
* | output |
* | --- |
* | "Monday’s promo gets prepared on Sunday night, so its quality depends on who happens to still be awake." |
*
* @param {Mk_Sol_Ukm_P3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_p3d = /** @type {((inputs?: Mk_Sol_Ukm_P3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_P3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_p3d(inputs)
	return en_mk_sol_ukm_p3d(inputs)
});